import classNames from 'classnames';

import React, { FC } from 'react';

import type { ImageProps } from '../image';
import { Image } from '../image';

import styles from './list-cell-image.scss';

const COMPONENT_ID = 'modulor-list-cell-image';

type Props = ImageProps & {
  size?: 'S' | 'L' | 'XL';
  withoutPadding: boolean;
  dataTestId?: string;
  placement?: 'left' | 'right';
  count?: number;
};

export const ListCellImage: FC<Props> = ({
  name,
  src,
  size = 'S',
  dataTestId = COMPONENT_ID,
  className,
  withoutPadding = false,
  placement = 'left',
  count,
  ...rest
}) => {
  if (!name && !src) {
    return null;
  }

  let imageSize;

  switch (size) {
    case 'L':
      imageSize = '56';
      break;
    case 'XL':
      imageSize = withoutPadding ? '84' : '68';
      break;
    default:
      imageSize = '24';
  }

  return (
    <div
      data-testid={dataTestId}
      data-id={dataTestId}
      data-component-name={COMPONENT_ID}
      className={classNames(styles.container, className, {
        [styles['counter-position-without-padding']]:
          (size === 'L' || size === 'XL') && withoutPadding,
        [styles['counter-position']]: (size === 'L' || size === 'XL') && !withoutPadding,
        [styles['without-left-padding']]: withoutPadding && placement === 'left',
        [styles['without-right-padding']]: withoutPadding && placement === 'right',
        [styles['large']]: size === 'XL',
        [styles['large-padding']]: size === 'S',
        [styles['right']]: placement === 'right',
      })}
      {...rest}>
      <Image
        name={name}
        src={src}
        width={imageSize}
        height={imageSize}
        count={count ? count : undefined}
      />
    </div>
  );
};
